import { CircleProgressBar } from '@web_opxp/components';
import * as React from 'react';
import { connect } from 'react-redux';
import * as Selectors from './selectors';
import SessionProgressItem from './SessionProgressItem';

export interface ISessionProgressProps {
  workouts: number[];
}

export const SessionProgressFC: React.FC<ISessionProgressProps> = ({ workouts }) => {
  return (
    <CircleProgressBar>
      {workouts.map((workoutId, index) => (
        <SessionProgressItem key={`${index}-${workoutId}`} index={index} workoutId={workoutId} />
      ))}
    </CircleProgressBar>
  );
};

export const mapStateToProps = (state: Selectors.IAppState) => {
  const workouts = Selectors.getSessionWorkouts(state);
  return {
    workouts,
  } as ISessionProgressProps;
};

const SessionOverview = connect(mapStateToProps)(SessionProgressFC);
export default SessionOverview;
